<template>
  <div :class="['category-tabs', 'sub-tabs', { 'locale-zh-CN': isZhLocale }]">
    <div class="sub-tabs-container">
      <div class="decorative-line left-line"></div>
      <div class="tab-group">
        <div 
          v-for="tab in tabs" 
          :key="tab.value"
          :class="['tab-item', { active: activeTab === tab.value }]"
          @click="handleTabClick(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="decorative-line right-line"></div>
    </div>
    <div v-if="showMore" class="more-link" @click="handleMoreClick">{{ moreText }}</div>
  </div>
</template>

<script>
import { getText } from '@/utils/i18nText'

export default {
  name: 'SubCategoryTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    activeTab: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    moreText: {
      type: String,
      default: () => getText('subCategoryTabs.moreText', '更多+')
    }
  },
  methods: {
    handleTabClick(value) {
      this.$emit('tab-change', value)
    },
    handleMoreClick() {
      this.$emit('more-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.category-tabs {
  margin-bottom: 20px;
  
  &.sub-tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 20px;
    width: 100%;
    
    .sub-tabs-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      position: relative;
      
      .decorative-line {
        flex: 1;
        height: 1px;
        background: #DFD6AA;
        
        &.left-line {
        }
        
        &.right-line {
        }
      }
      
      .tab-group {
        flex-shrink: 0;
        display: flex;
        gap: 8px;
        position: relative;
        z-index: 1;
        background: rgba(160, 144, 60, 0.1);
        border-radius: 18px;
        padding: 4px;
        
        .tab-item {
          background: transparent;
          color: #837423;
          border-radius: 18px;
          min-width: auto;
          padding: 0 16px;
          line-height: 35px;
          position: relative;
          z-index: 2;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          
          &:first-child,
          &:last-child {
            border-radius: 18px;
          }
          
          &.active {
            background: #A0903C;
            color: #FFFFFF;
            font-weight: 500;
            z-index: 3;
            
            &::after {
              display: none;
            }
          }
          
          &:hover:not(.active) {
            background: rgba(160, 144, 60, 0.1);
          }
        }
      }
    }
    
    .more-link {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #A0903C;
      line-height: 22px;
      cursor: pointer;
      margin-left: 20px;
      flex-shrink: 0;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &.locale-zh-CN.sub-tabs {
    .sub-tabs-container .tab-group .tab-item {
      font-size: 18px;
    }

    .more-link {
      font-size: 16px;
    }
  }
}
</style>

